import { form, AppendixForm, AppendixForm1 } from "./form";

const checkout = form;
const checkoutAppendix = AppendixForm;
const checkoutAppendix1 = AppendixForm1;
const {
  formField: {
    address,
    certificate,
    email,
    fax,
    fullName,
    firstTime,
    phone,
    signer,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxId2,
    taxpayerName,
    timeSign,
    BusinessAddress,
    taxAgentContract,
    conpanyName,
    conpanyTax,
  },
} = checkout;

const {
  formFieldAppendix: {
    taxCalculationPeriodAppendix,
    firstTimeAppendix,
    supplementaryForTheAppendix,
    taxpayerNameAppendix,
    taxIdAppendix,
  },
} = checkoutAppendix;

const {
  formFieldAppendix1: {
    taxCalculationPeriodAppendix1,
    firstTimeAppendix1,
    supplementaryForTheAppendix1,
    taxpayerNameAppendix1,
    taxIdAppendix1,
  },
} = checkoutAppendix1;

const initialValues = {
  [address.name]: "",
  [certificate.name]: "",
  [email.name]: "",
  [fax.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [phone.name]: "",
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [conpanyName.name]: "",
  [conpanyTax.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [taxId2.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
  [BusinessAddress.name]: "",
  [taxAgentContract.name]: "",

  //AppendixTable
  [taxCalculationPeriodAppendix.name]: "",
  [firstTimeAppendix.name]: "",
  [supplementaryForTheAppendix.name]: "",
  [taxpayerNameAppendix.name]: "",
  [taxIdAppendix.name]: "",
  //AppendixTable1
  [taxCalculationPeriodAppendix1.name]: "",
  [firstTimeAppendix1.name]: "",
  [supplementaryForTheAppendix1.name]: "",
  [taxpayerNameAppendix1.name]: "",
  [taxIdAppendix1.name]: "",
};

export default initialValues;
